import { render, staticRenderFns } from "./BosLogoListing.vue?vue&type=template&id=15b9096d&scoped=true"
import script from "./BosLogoListing.vue?vue&type=script&lang=js"
export * from "./BosLogoListing.vue?vue&type=script&lang=js"
import style0 from "./BosLogoListing.vue?vue&type=style&index=0&id=15b9096d&prod&lang=scss&scoped=true"
import style1 from "./BosLogoListing.vue?vue&type=style&index=1&id=15b9096d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b9096d",
  null
  
)

export default component.exports